export function createGetClass<T>(classes?: T | string) {
  return (path: keyof T) => {
    if (classes == null) {
      return;
    }

    if (typeof classes === 'undefined') {
      return;
    }

    if (typeof classes === 'string') {
      return;
    }

    return classes[path];
  };
}
